import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { routePaths } from "../../routePaths";
import { getDeploymentStats } from "../../services/pdmApi.service";

export default function Dashboard() {
  const navigate = useNavigate();
  const statsQuery = useQuery({
    queryKey: ["deploymentStats"],
    queryFn: getDeploymentStats,
  });

  const stats = statsQuery.data;

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ color: "brand.main" }}>
        Dashboard
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Overview of deployment activity across environments.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography color="text.secondary">Total success</Typography>
              <Typography variant="h4">
                {statsQuery.isLoading ? "—" : stats?.totalSuccess ?? 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography color="text.secondary">Total pending</Typography>
              <Typography variant="h4">
                {statsQuery.isLoading ? "—" : stats?.totalPending ?? 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography color="text.secondary">In progress</Typography>
              <Typography variant="h4">
                {statsQuery.isLoading ? "—" : stats?.inProgress ?? 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Fab
        color="primary"
        variant="extended"
        sx={{ position: "fixed", bottom: 24, right: 24 }}
        onClick={() => navigate(routePaths.deploymentCreate)}
      >
        <AddIcon sx={{ mr: 1 }} />
        Deploy a new ds-App
      </Fab>
    </Box>
  );
}
